import { makeAutoObservable, runInAction, toJS } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants"
import axios from 'axios';
import User from './UserStore';
import General from "../../src/stores/GeneralStore";

import {ErrorWrapper} from "../utils/ErrorWrapper"
import { NotifySuccess } from "../utils/ShowSuccess";
import { NotifyError } from "../../src/utils/ShowError";

interface CLData {
    [key: string]: string | undefined;
  }

export interface ComplaintType {
  key?: string;
  value?: string
}

export interface RegisterComplaintRequest {
  data: {
    complaintType: string;
    accountID: string;
    comment: string;
  },
  multiFileUpload: [
    {
      mediaType: string;
      fileName: string;
      buffer: string | null;
    }
  ]
}

interface PremiseQueryParams {
  premiseId: string;
}

class ComplaintAndLink {
  complaintTypes: any[] = [];
  feedbackTypes: any[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  getComplaintTypes = ErrorWrapper(async () => {
    let res = await callRemoteMethod({endpoint: CONSTANTS.URL.COMPLAINT_TYPES});
    console.log('hamza',res);
    this.complaintTypes = res.result?.categories;
    // console.log(this.complaintTypes);
  })
  feedback = ErrorWrapper(async (code:any) => {
    const response = await callRemoteMethod({endpoint: CONSTANTS.URL.FEEDBACK_AGAINST(code)});
    // this.feedbackTypes = response.result?.categories;
    runInAction(() => {
      this.feedbackTypes = response.result?.categories;
    });
    return response?.result;
    // console.log(this.feedbackTypes);
  })
  category = ErrorWrapper(async (data:any) => {
    const {code,subcode}=data;
    const response = await callRemoteMethod({endpoint: CONSTANTS.URL.CATEGORY_AGAINST(code,subcode)});
    // this.feedbackTypes = response.result?.categories;
    // runInAction(() => {
    //   this.feedbackTypes = response.result?.categories;
    // });
    return response?.result;
    // console.log(this.feedbackTypes);
  })

  submitComplaint = ErrorWrapper(async (data: any) => {
    let headers = await getRequestHeader({ currentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US" });
    const res:any=  await axios.post(CONSTANTS.URL.REGISTER_COMPLAINT, data, {
      headers
    })
    // if(res?.data?.result?.status=="S"){
    //   const message= General?.codeLabels[res?.data?.result?.message]?.label;
    //   const refId=res?.data?.result?.caseId;
    //   const updatedMessage = message.replace('{0}', refId);
    //   NotifySuccess(updatedMessage)
    // }
     if(res?.data?.result?.status=="F"){
      NotifyError(res?.data?.result?.message)
    }
    return res;
  })

  linkProperty = ErrorWrapper(async (data: PremiseQueryParams) => {
    return await callRemoteMethod({endpoint: CONSTANTS.URL.LINK_PROPERTY, data });
  })

  linkAccount = ErrorWrapper(async (data: PremiseQueryParams) => {
    const {premiseId}=data;
   const res= await callRemoteMethod({endpoint: CONSTANTS.URL.LINK_ACCOUNT(premiseId), type: 'POST'});
   return res;
  })

  connectedAccounts = ErrorWrapper(async () => {
    return await callRemoteMethod({endpoint: CONSTANTS.URL.CONNECTED_ACCOUNTS});
  })

  delinkAccount = ErrorWrapper(async (premiseId: string) => {
    const res = await callRemoteMethod({endpoint: CONSTANTS.URL.DELINK_PROPERTY(premiseId), type: 'POST'});
    return res;
  })
}

export async function getRequestHeader(options = { currentLanguage:localStorage.getItem("settingUplanguage") ?? "en-US"}) {
  let { info } = await User;
  var header = {
    Accept: `application/json`,
    'Content-Type': `application/json`,
    currentLanguage: options.currentLanguage,
    Authorization: ''
  };
  info.token && (header.Authorization = `Bearer ${info.token}`);

  return header;
}

const complaintAndLinkStore = new ComplaintAndLink()
export default complaintAndLinkStore;
